import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import AdminEdit from "../components/AdminEdit/AdminEdit";
import { fetchAdminDetail , updateAdmin, deleteAdmin} from "../actions/adminedit";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.adminEdit.isFetching,
    detail: state.adminEdit.detail,
    error: state.adminEdit.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAdminDetail,
      fetchUserInfo,
      updateAdmin,
      deleteAdmin
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminEdit);
